<footer class="footer center-align">© Copyrights 2021. All Rights Reserved</footer>
